import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import JBImage from 'components/essentials/JBImage';
import getAltFromSrc from 'commons/getAltFromSrc';
import { getThumbnailImageImgixPropsForPhoto } from '../PDPDesktopHeroGallery/helpers/imgix-props';

// Thumbnail tile shared by the rail and the expanded gallery grid
const PDPGalleryRevampLifestyleThumb = t0 => {
  const $ = _c(19);
  const {
    ariaLabel,
    borderClass: t1,
    children,
    className,
    icon,
    imgSize: t2,
    isSelected: t3,
    onClick,
    src,
    srcType: t4
  } = t0;
  const borderClass = t1 === undefined ? "border-gray-light7" : t1;
  const imgSize = t2 === undefined ? null : t2;
  const isSelected = t3 === undefined ? false : t3;
  const srcType = t4 === undefined ? "studio" : t4;
  let t5;
  if ($[0] !== borderClass || $[1] !== className || $[2] !== isSelected) {
    t5 = classNames("relative items-center flex justify-center overflow-hidden rounded border-solid bg-white", "hover:cursor-pointer hover:border-brand-dark focus-visible:outline-brand", isSelected ? "border-2 border-brand-dark" : classNames("border", borderClass), className);
    $[0] = borderClass;
    $[1] = className;
    $[2] = isSelected;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== imgSize || $[5] !== src || $[6] !== srcType) {
    t6 = !!src && (srcType === "cylindo" ? <img className="h-full w-full object-cover" src={src} alt={getAltFromSrc(src)} /> : <JBImage className="h-full w-full object-cover" forPage="pdp" lazy={false} alt={getAltFromSrc(src)} {...getThumbnailImageImgixPropsForPhoto({
      src,
      type: srcType
    })} {...imgSize} />);
    $[4] = imgSize;
    $[5] = src;
    $[6] = srcType;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== children) {
    t7 = !!children && <div className="text-xs font-bold text-gray">{children}</div>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== icon) {
    t8 = !!icon && <div className="absolute items-center flex justify-center inset-0">{icon}</div>;
    $[10] = icon;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== ariaLabel || $[13] !== onClick || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = <button type="button" aria-label={ariaLabel} onClick={onClick} className={t5}>{t6}{t7}{t8}</button>;
    $[12] = ariaLabel;
    $[13] = onClick;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
PDPGalleryRevampLifestyleThumb.propTypes = {
  ariaLabel: PropTypes.string,
  borderClass: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  imgSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  src: PropTypes.string,
  srcType: PropTypes.string
};
export default PDPGalleryRevampLifestyleThumb;